<template>
  <div>
    <el-container class="el-container-height">
      <el-header>
        <share/>
      </el-header>
      <el-main >
        <div class="left-nav">
          <div class="left-nav-content" style="position: relative;width:100%;height:100%;" >
            <router-link class="item" :to="item.url+id"
            v-for="(item,index) in navList" :key="index">
              <div class="item-icon"><svg-icon :iconClass="item.icon" /></div>
              <div class="item-name">{{item.title}}</div>
            </router-link>
          </div>
        </div>
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Share from './share';

export default {
  name: 'qms',
  components:{
    Share
  },
  data () {
    return {
      index:0,
      title:'题型',
      navList:[],
      id:'',
      titleList: [
        {
          title: '我的问卷',
          url: '/'
        },
        {
          title: '问卷类型'
        }
      ],
      showLeft:false
    }
  },
  methods: {
    showLeftNav(){
      this.showLeft = true;
    },
    toUrl (url) {
      this.$router.push(url)
    }
  },
  created () {
    this.id = this.$route.params.id;
    let editAuthList = JSON.parse(localStorage.getItem('editAuthList'));
    if(editAuthList && editAuthList.length > 0){
      let list = [
        {icon:'tixing',title:'题型',url:'/edit/'},
        {icon:'maxdiff',title:'MaxDiff',url:'/edit/maxdiff/'},
        {icon:'theme',title:'主题',url:'/edit/theme/'},
        {icon:'create',title:'结束页',url:'/edit/endPage/'},
        {icon:'luoji',title:'逻辑',url:'/edit/logic/'},
        {icon:'peizhi',title:'配额',url:'/edit/quota/'},
        {icon:'cascade',title:'级联',url:'/edit/template/'},
      ];
      let newList = [];
      list.forEach(item => {
        editAuthList.forEach(pre =>{
          if(item.icon == pre){
            newList.push(item);
          }
        })
      })
      this.navList = newList;
    }else {
      this.navList = [
        {icon:'tixing',title:'题型',url:'/edit/'},
        {icon:'maxdiff',title:'MaxDiff',url:'/edit/maxdiff/'},
        {icon:'theme',title:'主题',url:'/edit/theme/'},
        {icon:'create',title:'结束页',url:'/edit/endPage/'},
        {icon:'luoji',title:'逻辑',url:'/edit/logic/'},
        {icon:'peizhi',title:'配额',url:'/edit/quota/'},
        {icon:'cascade',title:'级联',url:'/edit/template/'},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  width: calc(100% - 70px);
  margin-left: 70px;
  background: #f5f6f7;
}
.el-container-height{
  height:100vh;
  .el-header{
    background: #fff;
    border-bottom: 1px solid #eceff1;
    box-shadow: 0 1px 3px rgba(0,0,0,.04);
  }
}
.router-link-active{
  .item-icon{
    background: #3370ff;
    .svg-icon{
      fill:#ffffff !important;
    }
  }
  .item-name{
    color:#3370ff !important;
  }
}
.left-nav{
  position: fixed;
  left:0;
  top:60px;
  z-index: 999;
  width: 70px;
  background: #fff;
  height: calc(100% - 60px);
  border-right: 1px solid #eceff1;
  box-shadow: none;
  .left-nav-content{
    padding:12px 6px;
    box-sizing: border-box;
    .item{
      text-decoration: none;
      .item-icon{
        width:100%;
        height:48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        transition: background .2s;
        .svg-icon{
          width:24px;
          height:24px;
          fill:#8f959e;
        }
      }
      .item-name{
        font-size: 11px;
        text-align: center;
        color:#8f959e;
        line-height: 20px;
        margin-bottom: 4px;
      }
      &:hover {
        .item-icon { background: #f0f3ff; }
        .item-name { color: #3370ff; }
      }
    }
    .open{
      position: absolute;
      top:0;
      right:-8px;
      bottom:0;
      width:8px;
      height:200px;
      background:#ccc;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      margin:auto;
      cursor: pointer;
    }
  }
}
.img{height:60px;width: 150px;position: absolute;left:20px;display: flex;align-items: center;}
.logo{width:150px;}
.footer{height:60px;line-height: 60px;text-align: center;color:#333;}
input:-webkit-autofill {-webkit-box-shadow: 0 0 0 1000px #fff inset;}
.login-container .el-input input:-webkit-autofill{-webkit-box-shadow: 0 0 0 1000px #fff inset !important;}
</style>



// WEBPACK FOOTER //
// src/views/layout/qms.vue